<template>
  <div>
    <div class="box has-background-white-bis" style="padding: 10px;">
      <b-field grouped v-for="(choice, key) in choices" :key="key">
        <b-input placeholder="Tambahkan Opsi" expanded v-model="choice.name" @input="onChangeChoice" maxlength="100"></b-input>
        <p class="control">
          <button class="button is-light has-text-grey" @click.prevent="deleteChoice(key)">
            <span class="icon">
              <b-icon icon="close"></b-icon>
            </span>
          </button>
        </p>
      </b-field>

      <b-field>
        <button class="button is-text has-text-link" @click.prevent="addChoice">
          <span class="icon">
            <b-icon icon="plus"></b-icon>
          </span>
          <span>Tambahkan Opsi</span>
        </button>
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onChangeChoices: {
      type: Function,
      default: () => {}
    },
    choicesData: {
      type: Array,
      default: () => {}
    }
  },

  watch: {
    choices(val) {
      this.onChangeChoices(val)
    }
  },

  data() {
    return {
      choices: !this.isEmpty(this.choicesData) ? _.cloneDeep(this.choicesData) : [
        { name: '' },
        { name: '' },
        { name: '' },
      ]
    }
  },

  methods: {
    addChoice() {
      this.choices.push({ name: '' })
    },
    deleteChoice(key) {
      this.choices = this.choices.filter((c, i) => key != i)
    },
    onChangeChoice() {
      this.onChangeChoices(this.choices)
    }
  },
}
</script>
